import React, { useState, useEffect } from "react";
import { Select, DatePicker, Input, Button, Form } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Filterloader from "../../../components/loader";
import * as zoneActions from "../../../redux/actions/zone.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";

const { RangePicker } = DatePicker;

const ApprovalHistoryFilters = (props) => {
  const { onFilterChange } = props;
  const [form] = Form.useForm();
  const [postDataZone, setPostDataZone] = useState(null);

  useEffect(() => {
    props.zoneActions.getZoneListAction();
  }, []);

  useEffect(() => {
    if (props.zoneData) {
      const zoneData = [];
      props.zoneData.forEach((item) => {
        if (!item?.storeId) return;
        zoneData.push({ value: String(item.storeId), label: item?.zoneName || item.storeId });
      });
      setPostDataZone(zoneData);
    }
  }, [props.zoneData]);

  const filterChange = async (value) => {
    const newData = {
      ...value,
      storeId: value?.storeId || "",
      orderId: value?.orderId || "",
      itemSku: value?.itemSku || "",
      page: 1,
    };
    if (onFilterChange) onFilterChange(newData);
  };

  const resetSearch = async () => {
    const today = moment();
    const newData = {
      page: 1,
      limit: 10,
      orderCreationDate: [moment(), moment()],
      storeId: "",
      orderId: "",
      itemSku: "",
    };
    form.resetFields();
    form.setFieldsValue({
      orderCreationDate: [today, today],
    });
    if (onFilterChange) onFilterChange(newData);
  };

  return props?.pageLoading ? (
    <Filterloader />
  ) : (
    <Form
      form={form}
      className="fliters_form"
      onFinish={filterChange}
      layout="vertical"
      initialValues={{
        orderCreationDate: [moment(), moment()],
      }}
    >
      <Form.Item name="orderId" label="Order ID">
        <Input allowClear style={{ width: 150 }} placeholder="Order ID" />
      </Form.Item>
      <Form.Item name="storeId" label="Zone">
        <Select
          showSearch
          allowClear
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          options={postDataZone}
          style={{ minWidth: 300 }}
          placeholder="Zone"
        />
      </Form.Item>
      <Form.Item name="itemSku" label="SKU">
        <Input allowClear style={{ width: 180 }} placeholder="SKU" />
      </Form.Item>
      <Form.Item name="orderCreationDate" label="Date">
        <RangePicker allowClear={false} format="YYYY-MM-DD" />
      </Form.Item>
      <Button htmlType="submit" loading={props?.pageLoading}>
        Search <SearchOutlined />
      </Button>
      <Button
        htmlType="button"
        type="primary"
        loading={props?.exportLoading}
        onClick={props?.onExportCsv}
      >
        Export CSV
      </Button>
      <Button loading={props?.pageLoading} onClick={resetSearch}>
        Reset
      </Button>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    zoneData: state.ZoneReducer.zoneData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    zoneActions: bindActionCreators(zoneActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ApprovalHistoryFilters);
